import React from 'react'
import LastMovie from './Home/LastMovie';

class About extends React.Component{
    render(){
        return (
            <div >
                <h1>About</h1>
                <p style={{ borderRadius: '15%'}}>I am a full stack software engineer with several years of professional experience.</p>
                <p style={{ borderRadius: '15%'}}>My hobbies outside of programming include weightlifting, gaming with friends, and reading zen & taoist literature.</p>
                <br />
                <LastMovie />
            </div>
            
        );
    }
}
export default About